import { Types } from '@sendum/core'
import React, { useCallback, useMemo, useRef, useState } from 'react'

import { Timeline } from '../../Timeline/Timeline'
import s from '../PalletSelector.module.scss'
import { Pallet } from './Pallet'

interface IProps {
    pallet: Types.Pallet
}

export const TimelineContainer = React.memo(
    ({ pallet }: IProps): JSX.Element => {
        const [isShowHeaderShadow, setShowHeaderShadow] = useState<boolean>(false)
        const containerRef = useRef<HTMLDivElement>(null)
        const [prevShipmentId, setPrevShipmentId] = useState<string>()

        const onScrollHandler = useCallback((event: React.UIEvent<HTMLDivElement>): void => {
            setShowHeaderShadow(event.currentTarget.scrollTop >= 1)
        }, [])

        const timeLine = useMemo(() => {
            console.debug(pallet.ShipmentId)
            if (!!prevShipmentId && prevShipmentId !== pallet.ShipmentId) {
                setTimeout(() => setPrevShipmentId(undefined), 10)

                return null
            }
            setPrevShipmentId(pallet.ShipmentId)

            const onLoadTimeLine = (_isShowHeaderShadow: boolean, _isShowFooterShadow: boolean): void => {
                setShowHeaderShadow(_isShowHeaderShadow)
            }

            return (
                <Timeline
                    shipmentId={pallet.ShipmentId}
                    isSubWidget
                    withManufacturingLabels
                    onLoaded={onLoadTimeLine}
                    onScroll={onScrollHandler}
                    showScrollShadow={{ top: false, bottom: true }}
                    noDataText={
                        <>
                            No Pallet
                            <br />
                            Assigned
                        </>
                    }
                />
            )
        }, [pallet.ShipmentId, onScrollHandler, prevShipmentId])

        return (
            <div className={`${s.PalletSelector__timelineContainer} ${s.timelineContainer}`} data-testid="timeline">
                <div className={s.timelineContainer__column}>
                    <div className={s.timelineContainer__pallet}>
                        <div
                            className={`${s.timelineContainer__timeline__header} ${
                                isShowHeaderShadow
                                    ? s.timelineContainer__timeline__shadowHeader
                                    : s.timelineContainer__timeline__normalHeader
                            }`}
                        />
                        <Pallet pallet={pallet} />
                    </div>
                    <div className={s.timelineContainer__timeline}>
                        <div
                            className={s.timelineContainer__timeline__container}
                            onScroll={onScrollHandler}
                            ref={containerRef}
                        >
                            {timeLine}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
)
